import { TabItemProps } from '@msaf/core-react'
import { createContext, useContext, PropsWithChildren, Dispatch, SetStateAction, useState } from 'react'

type PageState = {
  backLink?: {
    path: string
    label: string
  }
  heading?: string
  isFullScreen?: boolean
  headerTabs?: Array<TabItemProps>
}

const PageContext =
  createContext<{ pageState: PageState; setPageState: Dispatch<SetStateAction<PageState>> } | undefined>(undefined)

export default function PageProvider({ children }: PropsWithChildren<{}>) {
  const [pageState, setPageState] = useState<PageState>({})
  const value = { pageState, setPageState }
  return <PageContext.Provider value={value}>{children}</PageContext.Provider>
}

function usePageState() {
  const context = useContext(PageContext)
  if (context === undefined) {
    throw new Error('usePageState must be used within a PageProvider')
  }
  return context
}

export { usePageState }
